module.exports = __webpack_public_path__ + "img/step_five_en.6c4356e8.png";